<div class="color-picker">
    <div class="summary-info" (click)="toggleColors()">
        <div class="info">
            <p class="style">{{ heading }}</p>
            <p class="style-value">{{ color }}</p>
        </div>
        <div class="circle" [ngStyle]="{'background': color}"></div>
    </div>
    <div class="opened" *ngIf="show">
        <div class="colors">
            <div (click)="changeColor(paint)" *ngFor="let paint of defaultColors" class="circle"
                [ngStyle]="{'background': paint}"></div>

                <div class="form-group">
                    <label class="font-weight-bold ">eigen kleur:</label>
                    <input type="text" class="form-control" maxlength="7" [value]="color"
                        (keyup)="changeColorManual(paintInput.value)" #paintInput (keydown.enter)="toggleColors()" />
                </div>
                
        </div>
    </div>
</div>